import VFacebookLogin from 'vue-facebook-login-component-next';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VFacebookLogin)
})